import React, { Component } from 'react'
import './index.scss'
import logoIconTop from '../../assets/logoicon-top.png'
import iphoneIcon from '../../assets/iphone.png'
import logoIcon from '../../assets/logoicon.png'
import bigTitleBox from '../../assets/bigtitle.png'
import desBg from '../../assets/des-daoyu.png'
export default class Home extends Component {
  goAnimation = () => {

  }
  componentDidMount() {
    this.goAnimation()
  }
  render() {
    return (
      <div className="conBox homeBg" data-component="Home">
        <div className='imgBox1'>
          <img className="logoIconTop" src={logoIconTop} alt="logo" />
          <img className="logoIcon" src={logoIcon} alt="logo" />
          <img className="bigTitleBox" src={bigTitleBox} alt="logo" />
        </div>
        <div className='imgBox2'>
          <img className="iphoneIcon" src={iphoneIcon} alt="logo" />
          <img className="desBg" src={desBg} alt="logo" />
        </div>
        <div className='qpBox'>
          <span className='qpItem qpItem1'>新质生产力</span>
          <span className='qpItem qpItem2'>文旅融合</span>
          <span className='qpItem qpItem3'>扩大内需</span>
          <span className='qpItem qpItem4'>科技创新</span>
          <span className='qpItem qpItem5'>粮食安全</span>
          <span className='qpItem qpItem6'>数字化转型</span>
          <span className='qpItem qpItem7'>乡村振兴</span>
          <span className='qpItem qpItem8'>社会保障</span>
          <span className='qpItem qpItem9'>依法治国</span>
          <span className='qpItem qpItem10'>教育人才</span>
          <span className='qpItem qpItem11'>国家安全</span>
          <span className='qpItem qpItem12'>改革开放</span>
          <span className='qpItem qpItem13'>生态文明</span>
          <span className='qpItem qpItem14'>营商环境</span>
          <span className='qpItem qpItem15'>就业创业</span>
          <span className='qpItem qpItem16'>正风反腐</span>
          <span className='qpItem qpItem17'>医疗卫生</span>
          <span className='qpItem qpItem18'>交通运输</span>
        </div>
      </div>
    )
  }
}
